import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import GstFilterCriteria from './GstFilterCriteria'
import GstList from './GstList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './GstAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setGstDashboardGstList } from '../../store/slice/PharmaSlice';

export default function GstListView({setShowEdit,setGstId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.gstDashboard);   

    const [filteredGstList, setFilteredGstList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { gstDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (gstDashboard.gstList.length>-1){
        setFilteredGstList(gstDashboard.gstList);
        transformToCardFormat(gstDashboard.gstList, setCardList);
      }
    },[gstDashboard.gstList])

    useEffect(()=>{
          transformToCardFormat(filteredGstList, setCardList);
      },[filteredGstList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredGstList(gstDashboard.gstList);
            transformToCardFormat(gstDashboard.gstList, setCardList);

        } else {
            setFilteredGstList(
                gstDashboard.gstList
                    .filter(gst=> gst.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(gstDashboard.filteredGstList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <GstList
                    setShowEdit={setShowEdit}
                    setGstId = {setGstId}
                    tableList={filteredGstList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}